import { inputCommon } from '../inputCommon'
import type { FieldInputProps } from '../types'

/**
 * Placeholder REFERENCE: dziś bez rozwiązanej referenceTable UI -- plain text input,
 * wartość zapisana as-is. Pełna obsługa (autocomplete referencji) to F+.
 */
export function ReferenceInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <input
      type="text"
      id={`field-${field.fieldCode}`}
      className={inputCommon(disabled)}
      disabled={disabled}
      placeholder={field.referenceTable ? `Ref: ${field.referenceTable}` : undefined}
      value={value === null || value === undefined ? '' : String(value)}
      onChange={e => onChange(e.target.value)}
    />
  )
}
